import { render, staticRenderFns } from "./ResearchOutputDetailed.vue?vue&type=template&id=d94a3c80&scoped=true&"
import script from "./ResearchOutputDetailed.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputDetailed.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputDetailed.vue?vue&type=style&index=0&id=d94a3c80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94a3c80",
  null
  
)

export default component.exports